<template>
    <div :class="side === 'left' ? 'left-panel' : 'right-panel'" class="w-25">
        <!-- Top corner -->
        <div
            :class="[
                statusClasses,
                side === 'left' ? 'left-0' : 'right-0'
            ]"
            class="absolute h-6 w-20 top-0"
        ></div>

        <!-- Vertical bar -->
        <div
            :class="[
                statusClasses,
                side === 'left' ? 'inset-0' : 'ml-auto inset-0'
            ]"
            class="absolute h-full w-6"
        ></div>

        <!-- Bottom corner -->
        <div
            :class="[
                statusClasses,
                side === 'left' ? 'left-0' : 'right-0'
            ]"
            class="absolute bottom-0 h-6 w-20"
        ></div>
    </div>
</template>

<script>
import { getOccupationStatusClasses } from "../../utils/conferenceRoomOccupation";

export default {
    name: "StatusIndicatorBorder",

    props: {
        occupationStatus: {
            type: String,
            required: true,
            validator: (value) => ['free', 'occupied', 'soonOccupied'].includes(value),
        },
        side: {
            type: String,
            required: true,
            validator: (value) => ['left', 'right'].includes(value),
        },
    },

    computed: {
        statusClasses() {
            return getOccupationStatusClasses(this.occupationStatus);
        },
    },
};
</script>

<style scoped>
/* Panel positioning */
.left-panel {
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
}
.right-panel {
    position: fixed;
    right: 0;
    top: 0;
    height: 100%;
}
.w-25 {
    width: 25px;
}

/* Positioning */
.absolute {
    position: absolute;
}
.top-0 {
    top: 0;
}
.bottom-0 {
    bottom: 0;
}
.left-0 {
    left: 0;
}
.right-0 {
    right: 0;
}
.inset-0 {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}
.ml-auto {
    margin-left: auto;
}

/* Sizing */
.h-6 {
    height: 1.5rem;
}
.h-full {
    height: 100%;
}
.w-6 {
    width: 1.5rem;
}
.w-20 {
    width: 5rem;
}

/* Status Colors */
.bg-room-green {
    background-color: #22c55e;
}
.bg-room-red {
    background-color: #ef4444;
}
.bg-yellow-400 {
    background-color: #facc15;
}
</style>
